// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","menuItem":"menuItem_PMxFt","menuItemGray":"menuItemGray_nGYe7"};